import { features } from './definitions.js';
import { isDebugBuild } from './shared.js';

let featuresEnabled = new Set([
  ...features,
  ...(localStorage.getItem('features')?.split(',') || []),
]);

function isEnabled(name) {
  return featuresEnabled.has(name) && isDebugBuild;
}

export function storeFeatureEnabled(name, enabled) {
  if (enabled) {
    featuresEnabled.add(name);
  } else {
    featuresEnabled.delete(name);
  }
  localStorage.setItem('features', [...featuresEnabled].join(','));
}

export const FEATURE_FLAG_BANKING = isEnabled('BANKING');
export const FEATURE_FLAG_BILLING_INTERNAL = isEnabled('BILLING_INTERNAL');
export const FEATURE_FLAG_BILLING_SIMULATE_NEAR_LIMIT = isEnabled(
  'BILLING_SIMULATE_NEAR_LIMIT',
);
export const FEATURE_FLAG_BILLING_SIMULATE_EXCEEDED_LIMIT = isEnabled(
  'BILLING_SIMULATE_EXCEEDED_LIMIT',
);
export const FEATURE_FLAG_BILLING_SIMULATE_OVERDUE = isEnabled(
  'BILLING_SIMULATE_OVERDUE',
);
export const FEATURE_FLAG_BILLING_SIMULATE_SUSPENDED = isEnabled(
  'BILLING_SIMULATE_SUSPENDED',
);
export const FEATURE_FLAG_LOG_IN_WITHOUT_PASSWORD = isEnabled(
  'LOG_IN_WITHOUT_PASSWORD',
);
export const FEATURE_FLAG_SIGN_UP_ADD_AVATAR = isEnabled('SIGN_UP_ADD_AVATAR');
export const FEATURE_FLAG_MOBILE_APP_DOWNLOAD_LINK = isEnabled(
  'MOBILE_APP_DOWNLOAD_LINK',
);
export const FEATURE_FLAG_PREFERENCES = isEnabled('PREFERENCES');
export const FEATURE_FLAG_CONTRACT_FEE_CALCULATOR = isEnabled(
  'CONTRACT_FEE_CALCULATOR',
);
export const FEATURE_FLAG_TREASURY_CHART = isEnabled('TREASURY_CHART');
export const FEATURE_FLAG_EXTERNAL_TOKEN_SENDS = isEnabled(
  'EXTERNAL_TOKEN_SENDS',
);
export const FEATURE_FLAG_PAIRING_CODE = isEnabled('PAIRING_CODE');
export const FEATURE_FLAG_MODIFY_ORGANIZATIONS = isEnabled(
  'MODIFY_ORGANIZATIONS',
);
